import {createAction} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {batched} from '../../../../../redux/batch'
import * as api from '../../../apiCalls'
import {createActionObject} from '../../../../../redux/utils'
import {LOAD_DATA_FAILURE} from '../../../actionTypes'
import {isSelectUnlimitedUsers} from './selectors'
import {MIN_USERS_COUNT_FOR_ADD_USERS, PricingModelType, UNLIMITED_USERS_COUNT, USERS_LIMITED_PACKAGES} from '../../../constants'
import {getMaxUsersToUnlimited, getPricingModelType} from '../../../selectors'

export const setUsersCount = createAction(ActionTypes.USERS_COUNT_SET)
export const setUnlimited = createAction(ActionTypes.UNLIMITED_SET)
export const setPrice = createAction(ActionTypes.PRICE_SET)
export const setLicenseId = createAction(ActionTypes.LICENSE_ID_SET)

export const startAddUsers = license => (dispatch, getState) => {
    const state = getState()

    dispatch(setLicenseId(license.id))

    const maxUsersToUnlimited = getMaxUsersToUnlimited(state)
    if (license.usersCount >= maxUsersToUnlimited) {
        dispatch(calculatePriceForUnlimited(license.id))
    } else {
        const pricingModelType = getPricingModelType(state)
        if (pricingModelType === PricingModelType.USER) {
            dispatch(calculatePrice(license.id, MIN_USERS_COUNT_FOR_ADD_USERS))
        } else if (pricingModelType === PricingModelType.PACKAGE) {
            const nextPackage = USERS_LIMITED_PACKAGES.find(p => p > license.usersCount)
            dispatch(calculatePrice(license.id, nextPackage - license.usersCount))
        }
    }
}

export const cancelAddUsers = () => dispatch => dispatch(setLicenseId(0))

export const calculatePriceForUnlimited = (licenseId) => batched(dispatch => {
    dispatch(setUnlimited(true))
    dispatch(getPriceForAddingUsers(licenseId, UNLIMITED_USERS_COUNT))
})

export const calculatePrice = (licenseId, usersCount) => dispatch => {
    dispatch(setUsersCount(usersCount))
    dispatch(setUnlimited(false))
    dispatch(getPriceForAddingUsers(licenseId, usersCount))
}

export const getPriceForAddingUsers = (licenseId, usersCount) => (dispatch, getState) => {
    if (isSelectUnlimitedUsers(getState())) {
        usersCount = UNLIMITED_USERS_COUNT
    }

    api.getPriceForAddingUsers(licenseId, usersCount)
       .then((price) => {
           dispatch(setPrice(price))
       })
       .catch((error) => {
           dispatch(createActionObject(LOAD_DATA_FAILURE))
       })
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/licenseList/addUsers/actions.js